import Office from '@components/office';
import locationsSettings from '@static/cms/settings/locations.json';
import { Breakpoints, classNames } from '@utils';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/swiper.scss';
import styles from './locations.module.scss';

const Locations = ({ excludeByName }) => {
	const [swiperParams, setSwiperParams] = useState({});
	const offices = locationsSettings.offices.filter(o => o.name !== excludeByName);

	useEffect(() => {
		function getSwiper(swiper) {
			if (!swiper) {
				return false;
			}
			swiper.on('transitionEnd', () => {
				swiper.loopFix();
			});
		}

		setSwiperParams({
			loop: true,
			centeredSlides: true,
			slidesPerView: 'auto',
			getSwiper: getSwiper.bind(this)
		});
	}, []);

	const renderOffices = () =>
		offices.map((o, index) => (
			<div key={index} className={styles.location}>
				<Office {...o} />
			</div>
		));

	return (
		<Breakpoints>
			{breakpoint => {
				const carousel = ['xs', 'sm'].includes(breakpoint);
				return (
					<div
						className={classNames(
							'locations-carousel',
							styles.locations,
							carousel && styles.locationsCarousel
						)}
					>
						{carousel && <Swiper {...swiperParams}>{renderOffices()}</Swiper>}
						{!carousel && <React.Fragment>{renderOffices()}</React.Fragment>}
					</div>
				);
			}}
		</Breakpoints>
	);
};

Locations.propTypes = {
	excludeByName: PropTypes.string
};

Locations.defaultProps = {
	excludeByName: null
};

export default Locations;
